import "./App.css";
import { AppRouter } from "./components/router/AppRouter";

function App() {
  return <AppRouter />;
}

export default App;
